@if (isLoading) {
  <!-- Skeleton Loader -->
  <div class="skeleton-container">
    <p-skeleton
      borderRadius="12px"
      width="100%"
      height="100%"
      class="slide-skeleton"></p-skeleton>

    <p-skeleton
      borderRadius="12px"
      width="100px"
      height="16px"
      class="pagination-skeleton"></p-skeleton>
  </div>
}

@if (!isLoading) {
  <p-carousel
    [value]="slides"
    [numVisible]="1"
    [numScroll]="1"
    [circular]="newsBannerSlides && newsBannerSlides.length > 1"
    [autoplayInterval]="newsBannerSlides.length > 1 ? 10000 : null">
    <ng-template let-slide pTemplate="item">
      <app-news-banner-card
        [showButtons]="showButtons && newsBannerSlides.length > 0"
        [newsBannerSlide]="slide"
        (onDelete)="onDeleteSlide($event)"
        (onEdit)="onEditSlide($event)"></app-news-banner-card>
    </ng-template>
  </p-carousel>
}
